import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// === Fetch interceptor: inyecta el JWT en todos los fetch relativos ===
const originalFetch = window.fetch;
window.fetch = function(input, init) {
  // Solo para rutas relativas (que empiezan con /), no para URLs absolutas
  if (typeof input === 'string' && input.startsWith('/') && !input.startsWith('/api/auth/logout')) {
    const token = localStorage.getItem('auth_token');
    if (token) {
      init = init || {};
      init.headers = init.headers || {};
      // No sobrescribir Content-Type si ya está (FormData no lo necesita)
      if (init.headers instanceof Headers) {
        if (!init.headers.has('Authorization')) {
          init.headers.set('Authorization', `Bearer ${token}`);
        }
      } else if (typeof init.headers === 'object') {
        if (!init.headers['Authorization']) {
          init.headers['Authorization'] = `Bearer ${token}`;
        }
      }
    }
  }
  return originalFetch.call(this, input, init);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);

reportWebVitals();
